import React from 'react';
import { connect } from 'react-redux';
import { EditProfile } from '../Resources/EditProfile';
import { Profile } from './Profile';
import '../assets/styles/resource.css';
import PropTypes from 'prop-types';

class ArchivedEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainHtml: '',
      step: 'Profile',
      hash: this.props.match.params.hash,
    };
    this.profile = this.profile.bind(this);

    this.editProfile = this.editProfile.bind(this);
  }

  profile(hash) {
    this.setState({ step: 'Profile', hash: hash }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  editProfile(hash) {
    this.setState({ step: 'EditProfile', hash: hash }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    let options;

    if (this.state.step === 'Profile') {
      options = (
        <div>
          <Profile
            isArchivedEmployees={true}
            hash={this.state.hash}
            editProfile={this.editProfile}
          />
        </div>
      );
    }

    if (this.state.step === 'EditProfile') {
      options = (
        <div>
          <EditProfile
            goBack={this.profile.bind(this)}
            hash={this.state.hash}
            resourceDetails={this.state.props}
            id={this.state.id}
          />
        </div>
      );
    }

    this.setState({ mainHtml: options });
  }

  render() {
    return <div>{this.state.mainHtml}</div>;
  }
}

ArchivedEmployee.propTypes = {
  match: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const { vehicles } = state;
  return {
    vehicles,
  };
}

const connectedHomePage = connect(mapStateToProps)(ArchivedEmployee);
export { connectedHomePage as ArchivedEmployee };
